export const vedaFile = {
  pack<T extends any>(data: T) {
    return JSON.stringify(data);
  },
  unpack<T extends any>(data: string): T {
    return JSON.parse(data);
  },
};
